<template>
  <div class="my-4 mx-md-5 mx-lg-10 mx-xl-10 pa-2 pt-md-0 px-md-4 maxw-1750">

    <v-row class="pl-1 mt-2 mb-2"
    :style="{ gap: '1rem', display: 'flex', alignItems: 'center' }">

    <v-btn
      class="back"
      dark
      icon
      @click="historyBack"
    >
      <v-icon :style="{color: '#27846d !important', fontSize: '34px'}">
        icon-ayudadigital-volver
      </v-icon>
    </v-btn>

    <h2>{{ $t('views.pulsoDigitalProacS.title') }}</h2>

    <v-btn
      icon
      title="Ver mapa"
      id="no-background-hover"
      to="/pulsodigital/map"
      :style="{marginLeft: 'auto', marginRight: '1rem'}"
    >
      <v-icon size="40">icon-ayudadigital-chincheta</v-icon>
    </v-btn>

  </v-row>

    <v-row :style="{marginLeft: '0.5rem'}">
      <p>{{ $t('views.pulsoDigitalProacS.description') }}</p>
    </v-row>
    <v-card class="pt-2 pb-2 mt-2 mb-2" v-if="!loadingRequestTicket">
      <v-slide-group
        multiple
        show-arrows
      >
        <!-- <v-slide-item :disabled="tickets.length === 0"> -->
        <v-slide-item>
          <div class="container__chip">
            <span :class="'chip__agrupaciones chip__filter v-chip'">
              <div class="chipMenu">
                <v-menu>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      density="compact"
                      variant="text"
                      v-on="on"
                      class="btn__filter"
                      :ripple="false"
                      @click="()=>{menuFlags = !menuFlags}"
                    >
                      <span>
                        <b>Estados:</b> {{ findStatusName() }}
                      </span>
                      <v-icon class="iconChips">
                      {{
                        !menuFlags ?
                          'mdi-chevron-up' :
                          'mdi-chevron-down'
                      }}
                    </v-icon>
                  </v-btn>
                  </template>
                  <v-list class="listSheet">
                    <template
                      v-for="(item, index) in statusFilter"
                      >
                      <v-list-item
                        link
                        class="listSheetItem"
                        :key="index +1 * 17 + item.value"
                      >
                        <v-list-item-title class="listSheetTitle"
                        @click="handleStatusFilter(item)">
                          <v-icon size="16" class="iconChips iconChipSize">
                            {{
                              item.active ?
                              'mdi-check-bold' : ''
                            }}
                          </v-icon>
                          <v-badge
                            v-if="item.color"
                            class="d-inline"
                            inline
                            :color="item.color ? item.color : ''"
                            dot
                          ></v-badge>
                          {{ item.label }}
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-menu>
              </div>
            </span>
            <span :class="'chip__agrupaciones chip__filter v-chip'">
              <div class="chipMenu">
                <v-menu>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      density="compact"
                      variant="text"
                      v-on="on"
                      class="btn__filter"
                      :ripple="false"
                      @click="()=>{menuFlagsNodo = !menuFlagsNodo}"
                    >
                      <span>
                        <b>Nodos:</b> {{ findNodoName() }}
                      </span>
                      <v-icon class="iconChips">
                      {{
                        !menuFlags ?
                          'mdi-chevron-up' :
                          'mdi-chevron-down'
                      }}
                    </v-icon>
                  </v-btn>
                  </template>
                  <v-list class="listSheet">
                    <template
                      v-for="(item, index) in nodoFilters"
                      >
                      <v-list-item
                        link
                        class="listSheetItem"
                        :key="index +1 * 17 + item.value"
                      >
                        <v-list-item-title class="listSheetTitle"
                        @click="handleNodoFilter(item)">
                          <v-icon size="16" class="iconChips iconChipSize">
                            {{
                              item.active ?
                              'mdi-check-bold' : ''
                            }}
                          </v-icon>
                          {{ item.label }}
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-menu>
              </div>
            </span>
          </div>
        </v-slide-item>
      </v-slide-group>
    </v-card>
    <template v-if="loadingRequestTicket">
      <template >
        <v-card class="mt-4 py-2">
          <v-skeleton-loader
            v-for="i in 7"
            :key="i"
            type="list-item"
            class="mx-auto"
          ></v-skeleton-loader>
        </v-card>
      </template>
    </template>

    <template v-else>
      <div
        class="mt-2 hoverItem"
        v-if="tickets && tickets.length > 0"
      >
        <ListItem
          v-for="(ticket, index) in tickets.slice(0, pagesize * page)"
          :key="index"
          class="pt-1"
        >
          <template v-slot:title>
            <div class="inlineFlexMW90">
              <div class="alignItemCenter titleTicket">
                <v-avatar
                  v-if="ticket.status != null"
                  class="initialColor mr-3"
                  :color="ticket.status ? colors(ticket.status) : ''"
                  size="32"
                >
                  <v-icon
                    class="initialColorIcon"
                    :color="colors(ticket.status)"
                    v-text="textIcon(ticket)"
                  ></v-icon>
                </v-avatar>
                <span
                  v-if="$vuetify.breakpoint.mdAndUp"
                  v-bind:class="['item-title', {
                    'item-title-end': !$vuetify.breakpoint.smAndUp
                  }]"
                  @click="() => navigateToDetail(ticket, tickets)"
                >
                  <i class="titleTicket"> {{ ticket.ref_num }}</i> -
                  {{ ticket.summary.slice(20) }} -
                  {{ ticket.tipificacion }} - {{ ticket.localizacion }}
                </span>

                <v-spacer />

                <span
                  v-if="!$vuetify.breakpoint.mdAndUp"
                  style="width: 100%"
                  v-bind:class="['item-title', {
                    'item-title-end': !$vuetify.breakpoint.smAndUp
                  }]"
                  @click="() => navigateToDetail(ticket, tickets)"
                >
                <i class="titleTicket"> {{ ticket.ref_num }}</i> -
                  {{ ticket.summary.slice(20) }} -
                  {{ ticket.tipificacion }} - {{ ticket.localizacion }}
                </span>

                <div class="botonSeguir">
                  <v-btn
                    icon
                    title="Seguir"
                    id="no-background-hover"
                    @click="() => createSuscription(ticket)"
                  >
                    <v-icon size="30">icon-ayudadigital-ojo-negativo</v-icon>
                  </v-btn>
                </div>

                <div class="botonHorarios">
                  <v-btn
                    icon
                    title="Horarios"
                    id="botonHorarios"
                    @click.stop="toggleHorarios(ticket)"
                  >
                    <v-icon color="primary" size="30">mdi-av-timer</v-icon>
                  </v-btn>
                  <v-list
                    v-if="isHorarioOpen(ticket)"
                    class="horariosListSheet"
                  >
                      <h3 class="pl-1 pb-2 text-center w-100 titleHC">
                        Horario centros
                        <v-btn
                          id="botonHorariosAspa"
                          elevation="2"
                          icon
                          outlined
                          class="btn-no-style"
                          @click.stop="toggleHorarios(ticket)"
                        >
                          <v-icon size="20">mdi-close</v-icon>
                        </v-btn>
                      </h3>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-title>
                          <v-row>
                            <v-col cols="5">
                              Lunes:
                            </v-col>
                            <v-col cols="7">
                              {{ ticket.zh_lunes ? ticket.zh_lunes : '-' }}
                            </v-col>
                          </v-row>
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-title>
                          <v-row>
                            <v-col cols="5">
                              Martes:
                            </v-col>
                            <v-col cols="7">
                              {{ ticket.zh_martes ? ticket.zh_martes : '-' }}
                            </v-col>
                          </v-row>
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-title>
                          <v-row>
                            <v-col cols="5">
                              Miércoles:
                            </v-col>
                            <v-col cols="7">
                              {{ ticket.zh_miercoles ? ticket.zh_miercoles : '-' }}
                            </v-col>
                          </v-row>
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-title>
                          <v-row>
                            <v-col cols="5">
                              Jueves:
                            </v-col>
                            <v-col cols="7">
                              {{ ticket.zh_jueves ? ticket.zh_jueves : '-' }}
                            </v-col>
                          </v-row>
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-title>
                          <v-row>
                            <v-col cols="5">
                              Viernes:
                            </v-col>
                            <v-col cols="7">
                              {{ ticket.zh_viernes ? ticket.zh_viernes : '-' }}
                            </v-col>
                          </v-row>
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-title>
                          <v-row>
                            <v-col cols="5">
                              Sábado:
                            </v-col>
                            <v-col cols="7">
                              {{ ticket.zh_sabado ? ticket.zh_sabado : '-' }}
                            </v-col>
                          </v-row>
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item>
                        <v-list-item-title>
                          <v-row>
                            <v-col cols="5">
                              Domingo:
                            </v-col>
                            <v-col cols="7">
                              {{ ticket.zh_domingo ? ticket.zh_domingo : '-' }}
                            </v-col>
                          </v-row>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                </div>
              </div>
            </div>
          </template>

          <template v-slot:subtitle>
            <div v-html="(ticket.description || '').replace(/\n/ig, '<br>')"></div>
            <v-spacer />
          </template>

          <template v-slot:footer class="pa-0">
            <template v-if="ticket.open_date">
              {{ $t("views.ticketList.openDate", [ $date('formatTime', ticket.open_date) ]) }}
            </template>
          </template>
        </ListItem>

        <InfiniteScroll
          margin="200px"
          root="html"
          class="mt-4"
          @scrollList="scrollTickets()"
        ></InfiniteScroll>
      </div>
      <div v-else>
        <v-card
        :style="{padding: '1rem'}">
          <p> {{ $t('views.pulsoDigitalProacS.empty') }}</p>
        </v-card>
      </div>
    </template>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  ListItem, InfiniteScroll,
} from '@/components';

export default {
  name: 'TicketsListView',
  components: {
    ListItem,
    InfiniteScroll,
  },
  computed: {
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),
  },
  data() {
    return {
      tickets: [],
      start: 0,
      pagesize: 15,
      page: 1,
      total: 0,
      scroll: true,
      pathname: null,
      loadingRequestTicket: true,
      isBadge: true,
      filters: {},
      suscriptorList: [],
      codigoSeguidor: 400002,
      activeFilters: [],
      statusFilter: [
        {
          label: 'Abierta',
          value: 'OP',
          color: '#e2e200',
          active: true,
        },
        {
          label: 'Pte. implantar',
          value: 'PL_ENT',
          color: '#e2e200',
          active: true,
        },
        {
          label: 'Planificada',
          value: 'DEL',
          color: '#ed7d31',
          active: true,
        },
        {
          label: 'Pte. confirmar cierre',
          value: 'FIX',
          color: '#ed7d31',
          active: false,
        },
      ],
      nodoFilters: [
        {
          label: 'Centralizados',
          value: '400112',
          color: '#808080',
          active: true,
        },
        {
          label: 'Córdoba',
          value: '400001',
          color: '#808080',
          active: true,
        },
        {
          label: 'Almería',
          value: '400002',
          color: '#808080',
          active: true,
        },
        {
          label: 'Cádiz',
          value: '400003',
          color: '#808080',
          active: true,
        },
        {
          label: 'Granada',
          value: '400004',
          color: '#808080',
          active: true,
        },
        {
          label: 'Huelva',
          value: '400005',
          color: '#808080',
          active: true,
        },
        {
          label: 'Jaén',
          value: '400006',
          color: '#808080',
          active: true,
        },
        {
          label: 'Málaga',
          value: '400007',
          color: '#808080',
          active: true,
        },
        {
          label: 'Sevilla',
          value: '400008',
          color: '#808080',
          active: true,
        },
        {
          label: 'SSA',
          value: '400009',
          color: '#808080',
          active: true,
        },
      ],
      menuFlags: false,
      menuFlagsNodo: false,
      activeHorarioTicket: null,
    };
  },
  // Variable estática para cache
  statics: {
    sandetelCache: null,
  },
  methods: {
    navigateToDetail(ticket, tickets) {
      const idTicketAux = ticket.label;
      const idTicket = idTicketAux.substring(3);
      const listProactivas = tickets.map((i) => i.label.substring(3));
      this.$router.push({
        name: 'TicketDetailTicViewProact',
        params: {
          idTicket,
          pulsoDataExt: ticket,
          isTIC: true,
          list: listProactivas,
          getListProac: this.getListProac,
        },
      });
    },
    historyBack() {
      this.$router.push('/pulsodigital');
    },
    textIcon(ticket) {
      if (ticket?.status) {
        const result = this.$getConst(`initialFilters.filterStatus.${ticket.status}.initials`);
        return result;
      }
      return '';
    },
    colors(status) {
      if (status) {
        const result = this.$getConst(`initialFilters.filterStatus.${status}.color`);
        return result;
      }
      return '';
    },
    toggleHorarios(ticket) {
      if (this.activeHorarioTicket === ticket.ref_num) {
        this.activeHorarioTicket = null;
        return;
      }
      this.activeHorarioTicket = ticket.ref_num;
    },
    toogleHorariosClose() {
      this.activeHorarioTicket = null;
    },
    isHorarioOpen(ticket) {
      return this.activeHorarioTicket === ticket.ref_num;
    },
    async scrollTickets() {
      // scrollTickets
      if (this.tickets && this.tickets.length
      && this.pagesize * this.page < this.total) {
        this.page += 1;
      }
    },
    async createSuscription(ticket) {
      /* TODO COGER DATOS DE TICKETS O REFERENCIAR TICKET EN DADA */
      const messageId = await this.$store.dispatch(
        'messages/createNotificationMessage',
        {
          icon: 'progress-circular',
          title: this.$t('views.pulsoDigital.addSubscription'),
        },
      );
      await this.getSuscriptor(ticket);
      const isSuscriptor = this.getSeguidor();
      if (!isSuscriptor) {
        await this.addSuscriptor({ messageId, ticket });
      } else {
        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          type: 'success',
          icon: 'mdi-close-circle',
          title: this.$t('views.pulsoDigital.errorSubscription'),
          timeout: this.$getConst('notifications.timeout'),
        });
      }
    },
    async getSuscriptor(ticket) {
      const { ref_num: referenceNumber } = ticket;
      const uuidAplicacionOrigen = this.$getConst('uuidAplicacion.origen');

      try {
        const { id, userid } = this.$store.getters['session/user'];
        const response = await this.suscriptorsClient.getListSuscriptorsSolicitud({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: `cges/solicitudes/${ referenceNumber }/suscriptores?uuidAplicacionOrigen=${ uuidAplicacionOrigen }`,
          },
          id: referenceNumber,
        });
        if (response?.collection_suscriptors?.suscriptors.length > 0) {
          this.suscriptorList = response.collection_suscriptors.suscriptors.map((item) => ({
            name: item.nombre,
            uuid: item.uuid,
            codigoFlujo: item.flujo.id,
          }));
        }
      } catch (error) {
        console.log(error);
      }
    },
    getSeguidor() {
      const { id } = this.$store.getters['session/user'];
      /* TODO COGER DATOS DE TICKETS O REFERENCIAR TICKET EN DADA */
      const segudorOnly = this.suscriptorList
        .filter((item) => item.codigoFlujo === this.codigoSeguidor);

      return segudorOnly
        .some((suscriptor) => suscriptor.uuid === id);
    },
    async addSuscriptor({ messageId, ticket }) {
      const { ref_num: referenceNumber } = ticket;
      const { label: persidAux } = ticket;

      const ticketID = persidAux.replace(/\D/g, '');
      try {
        const { id, userid, name } = this.$store.getters['session/user'];

        const idTagApp = this.$getConst('tagActivity.follow.idTagApp');
        const idTagWeb = this.$getConst('tagActivity.follow.idTagWeb');
        const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;
        const tagActivity = isMobile ? idTagApp : idTagWeb;

        const descriptionActivity = `${name} ha seguido esta solicitud`;

        const response = await this.suscriptorsClient.postSuscriptors({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: `cges/solicitudes/${ referenceNumber }/suscriptores`,
          },
          id: referenceNumber,
          suscriptorAll: id,
          flujo: {
            id: this.codigoSeguidor,
          },
          descriptionActivity,
          zvirtualActivity: id,
          tagActivity,
          ticketID,
        });

        if (response.status === 200) {
          this.$store.dispatch('messages/updateMessage', {
            id: messageId,
            type: 'success',
            icon: 'mdi-check-circle',
            title: `${this.$t('views.pulsoDigital.createSubscription')}`,
            timeout: this.$getConst('notifications.timeout'),
          });
        } else {
          this.$store.dispatch('messages/updateMessage', {
            id: messageId,
            type: 'error',
            icon: 'mdi-close-circle',
            title: this.$t('views.pulsoDigital.koSubscription'),
            timeout: this.$getConst('notifications.timeout'),
          });
        }
      } catch (error) {
        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          type: 'error',
          icon: 'mdi-close-circle',
          title: this.$t('views.pulsoDigital.koSubscription'),
          timeout: this.$getConst('notifications.timeout'),
        });
      }
      this.$emit('input');
    },
    async getListProac() {
      return this.tickets;
    },
    isUserTic() {
      const user = this.$store.getters['session/user'];
      return user.accessTypeTic;
    },
    isCitizen() {
      return this.user.hasIosUser();
    },
    findStatusName() {
      return this.statusFilter
        .filter((item) => item.active)
        .map((item) => item.label)
        .join(', ');
    },
    findNodoName() {
      return this.nodoFilters
        .filter((item) => item.active)
        .map((item) => item.label)
        .join(', ');
    },
    handleStatusFilter(item) {
      this.statusFilter.forEach((elem) => {
        if (item.value === elem.value) {
          // eslint-disable-next-line no-param-reassign
          elem.active = !elem.active;
        }
      });
      // this.$options.statics.sandetelFiltersCache = this.statusFilter;
      // Esto se actualizara conforme se vayan añadiendo filtros
      this.getActiveFilters();
      this.fillSelectedProac();
      this.menuFlags = !this.menuFlags;
      this.toogleHorariosClose();
    },
    handleNodoFilter(item) {
      this.nodoFilters.forEach((elem) => {
        if (item.value === elem.value) {
          // eslint-disable-next-line no-param-reassign
          elem.active = !elem.active;
        }
      });
      // this.$options.statics.sandetelFiltersCache = this.statusFilter;
      // Esto se actualizara conforme se vayan añadiendo filtros
      this.getActiveFilters();
      this.fillSelectedProac();
      this.menuFlagsNodo = !this.menuFlagsNodo;
      this.toogleHorariosClose();
    },
    getActiveFilters() {
      const statusFilter = this.statusFilter.filter((item) => item.active);
      const nodoFilter = this.nodoFilters.filter((item) => item.active);
      this.activeFilters = {
        status: statusFilter,
        nodo: nodoFilter,
      };
    },
    fillSelectedProac() {
      // Cache this.$options.statics.sandetelCache (Primer listado realizado con todas sin filtrar)
      // Recogemos en un Array los filtros activos
      const statusActive = [];
      const nodoActive = [];
      this.activeFilters.status.forEach((item) => {
        if (item.active) {
          statusActive.push(item.value);
        }
      });
      this.activeFilters.nodo.forEach((item) => {
        if (item.active) {
          nodoActive.push(item.value);
        }
      });
      // Aqui filtraremos por estado la lista
      // eslint-disable-next-line array-callback-return, consistent-return
      this.tickets = this.$options.statics.sandetelCache.filter((item) => {
        console.log('statusActive', item);
        if (statusActive.includes(item.status) && nodoActive.includes(String(item.nodo_id))) {
          return item;
        }
      });
    },
  },

  async created() {
    if (!this.isUserTic() || this.isCitizen()) {
      this.$store.dispatch('messages/createNotificationMessage', {
        title: 'No tienes permiso para visualizar esta funcionalidad',
        type: 'error',
        timeout: this.$getConst('notifications.timeoutPlus'),
        dismissible: true,
      });

      if (this.isCitizen()) {
        this.$router.push('/');
      } else {
        this.$router.push('/pulsodigital');
      }
    } else {
      this.userClient = this.$api.getClient('user');
      this.suscriptorsClient = this.$api.getClient('suscriptors');
      const filters = {
        statusIncidencia: ['OP', 'DEL', 'PL_ENT', 'FIX'],
      };
      // Usa la cache si existe
      if (this.$options.statics.sandetelCache) {
        this.tickets = this.$options.statics.sandetelCache;
        // this.statusFilter = this.$options.statics.sandetelFiltersCache;
        this.getActiveFilters();
        this.fillSelectedProac();
      } else {
        this.tickets = await this.$api.getClient('solicitudes').getSandetel(filters);
        this.$options.statics.sandetelCache = this.tickets;

        this.getActiveFilters();
        this.fillSelectedProac();
      }
      // statusIncidencia: ['OP', 'DEL', 'PL_ENT', 'FIX'],
      // this.tickets = await this.$api.getClient('solicitudes').getSandetel(filters);
      // this.search(query);
      this.total = this.tickets.length;
      this.loadingRequestTicket = false;
      this.pathname = window.location.pathname;
    }
  },
};
</script>

<style lang="scss" scoped>
  .horariosListSheet{
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    z-index: 5;
    min-width: 220px;
    background: white;
    border: 1px solid #dcdcdc;
    border-radius: 0.4rem;
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
      0px 8px 10px 1px rgba(0, 0, 0, 0.14),
      0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  }
  .botonHorarios {
    position: relative;
    display: inline-flex;
  }
  .item-title {
    cursor: pointer;
  }
  .item-title-end {
    word-break: keep-all;
  }
  .initialColor{
    font-size: 0.5rem !important;
  }
  .initialColorIcon{
    color: #ffffff !important;
    font-size: 14px !important;
  }
  .icon__interesado--request {
    font-size: 3rem
  }
  .icon__seguidor--request {
    font-size: 2.5rem
  }
  .iconNone {
    height: 45px;
    width: 32px;
  }
  .hoverItem :hover{
    background-color: #c8c8c8;
  }
  .inlineFlexMW90{
    display: inline-flex;
    max-width: 95% !important;
  }
  .alignItemCenter{
    display: flex;
    align-items: center !important;
  }
  .iconTicket{
    min-width: 50px !important;
  }
  .titleTicket{
    font-size: 0.95rem !important;
  }
  .botonSeguir{
    display: block;
  }
  .chip__filter{
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    padding-left: 8px !important;
    padding-right: 0px !important;
  }
  .chipMenu{
    display: flex;
    align-items: center;
  }
  .btn__filter {
    height: 20px !important;
    width: 100% !important;
    text-transform: initial;
    color: initial !important;
    letter-spacing: initial !important;
  }
  .btn__filter,
  .btn__filter:focus,
  .btn__filter:active,
  .btn__filter::before {
    background-color: transparent !important;
  }
  .container__chip {
    margin-left: 0rem;
    padding: 0px !important;
  }
  .v-chip:hover {
    cursor: pointer;
  }
  .iconChips{
    color:#27846d !important;
  }
  .iconChipSize{
    min-width: 16px !important;
    max-width: 16px !important;
  }
  .listSheet{
    background: white;
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
      0px 8px 10px 1px rgba(0, 0, 0, 0.14),
      0px 3px 14px 2px rgba(0, 0, 0, 0.12) !important;
    display: grid;
    border: 1px green solid;
    border-radius: 0.4rem;
    padding: 0px !important;
  }
  .listSheetItem{
    display: block;
    min-height: 1rem;
    padding: 0.25rem;
  }
  .v-menu__content{
    margin-top:2.5rem;
    box-shadow: none !important;
    min-width: 220px !important;
  }
  .btn-no-style {
    min-width: 0 !important;
    max-width: 24px !important;
    max-height: 24px !important;
    width: auto !important;
    height: auto !important;
    padding: 0 !important;
    margin: 0 !important;
    margin-left: 16px !important;
    border: 1 !important;
  }
  .titleHC{
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  @media screen and (max-width: 600px) {
    .titleTicket{
      font-size: 0.85rem !important;
    }
    .showWeb {
      display: none !important;
    }

    .v-slide-group__next--disabled {
      display: none !important;
    }

    .v-slide-group__next {
      min-width: none !important;
    }
    .myRequestScroll{
      overflow: hidden;
      white-space: nowrap;
      overflow-x: auto;
      padding-bottom: 4px;
    }
    .inlineFlexMW90{
      max-width: 90% !important;
    }

  }

</style>
